import { useContext, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AuthContext from "../../store/AuthContext";
import { useEnsureManageFirmLoaded } from "../../hooks/useEnsureManageFirmLoaded";
import { Appstore, manageFirmSlice } from "../../redux";

/**
 * Layout for data-admin routes under /manage-firm.
 * Loads the logged-in user's firm into Redux (not from URL params).
 */
const DataAdminFirmLayout = () => {
  const { loggedPerson, isAuthenticated, tokenDecoded } =
    useContext(AuthContext);
  const dispatch = useDispatch();
  const selectedFirmId = useSelector(
    (s: Appstore) => s.manageFirm.selectedFirm?.id,
  );
  const firmId = loggedPerson?.firm;

  useEnsureManageFirmLoaded(firmId);

  useEffect(() => {
    return () => {
      dispatch(manageFirmSlice.actions.SetFirm(undefined));
    };
  }, [dispatch]);

  // loggedPerson loads async in AuthContext; don't redirect until it resolves.
  if (isAuthenticated && tokenDecoded && loggedPerson === undefined) {
    return null;
  }

  if (!firmId) {
    return <Navigate to="/mywsg" replace />;
  }

  if (selectedFirmId !== firmId) {
    return null;
  }

  return <Outlet />;
};

export default DataAdminFirmLayout;
